import { ApiError } from '../errors/api-error.js';

export class ReportSurfacesService {
    constructor(api) { this.api = api; }

    async describeMany(surfaceKeys) {
        try {
            const response = await this.api.describeMany(surfaceKeys);
            return { success: response.success ?? true, data: response.data ?? response };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report surface request failed');
        }
    }

    async describe(surfaceKey) {
        try {
            const response = await this.api.describe(surfaceKey);
            return { success: response.success ?? true, data: response.data ?? response };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report surface request failed');
        }
    }
}
